// Import statements
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

// Create pendingContract API
const pendingContractAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'pendingContractAPI',
    endpoints: (builder) => ({

        getPendingContractsList: builder.mutation({
            query: (data) => ({
                url: `PendingContract/GetPendingContractsList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getActiveClients: builder.mutation({
            query: (data) => ({
                url: `PendingContract/GetActiveClients`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addPendingContract: builder.mutation({
            query: (data) => ({
                url: `PendingContract/AddPendingContract`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deletePendingContract: builder.mutation({
            query: (plPendingContractKey) => ({
                url: `/PendingContract/DeletePendingContract?plPendingContractKey=${plPendingContractKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPendingContractById: builder.query({
            query: (data) => ({
                url: `/PendingContract/GetPendingContractById?plPendingContractKey=${data.plPendingContractKey}&pbIncludeInactive=${data.pbIncludeInactive}&psPendingContractName=${data.psPendingContractName}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getClientByPendingContractId: builder.query({
            query: (data) => ({
                url: `/PendingContract/getClientByPendingContractId?plPendingContractKey=${data.plPendingContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPendingContractDepartments: builder.query({
            query: ({ plPendingContractKey, plClientKey }) => ({
                url: `/PendingContract/GetPendingContractDepartments?plPendingContractKey=${plPendingContractKey}&plClientKey=${plClientKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPendingContractDepartmentsAvailable: builder.query({
            query: (plPendingContractKey) => ({
                url: `/PendingContract/GetPendingContractDepartmentsAvailable?plPendingContractKey=${plPendingContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addPendingContractDepartments: builder.mutation({
            query: (data) => ({
                url: `/PendingContract/AddPendingContractDepartments`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deletePendingContractDepartment: builder.mutation({
            query: ({ plPendingContractKey, plDepartmentKey }) => ({
                url: `/PendingContract/DeletePendingContractDepartment?plPendingContractKey=${plPendingContractKey}&plDepartmentKey=${plDepartmentKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPendingContractAffiliates: builder.query({
            query: (data) => ({
                url: `/PendingContract/GetPendingContractAffiliates?plPendingContractKey=${data.plPendingContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addPendingContractAffiliate: builder.mutation({
            query: (data) => ({
                url: `PendingContract/AddPendingContractAffiliate`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deletePendingContractAffiliate: builder.mutation({
            query: (data) => ({
                url: `/PendingContract/DeletePendingContractAffiliate`,
                method: 'DELETE',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPendingContractScopes: builder.query({
            query: (plPendingContractKey) => ({
                url: `/PendingContract/GetPendingContractScopes?plPendingContractKey=${plPendingContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPendingContractScopesAvailable: builder.query({
            query: (plPendingContractKey) => ({
                url: `/PendingContract/GetPendingContractScopesAvailable?plPendingContractKey=${plPendingContractKey}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addPendingContractScope: builder.mutation({
            query: (data) => ({
                url: `/PendingContract/AddPendingContractScope`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deletePendingContractScope: builder.mutation({
            query: ({plPendingContractKey,plScopeKey}) => ({
                url: `/PendingContract/DeletePendingContractScope?plPendingContractKey=${plPendingContractKey}&plScopeKey=${plScopeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAffiliateDepartment: builder.mutation({
            query: (data) => ({
                url: `PendingContract/GetAffiliateDepartment`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        savePendingContractScopes: builder.mutation({
            query: (data) => ({
                url: `PendingContract/SavePendingContractScopes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deletePendingContractScopeType: builder.mutation({
            query: (plPendingContractScopeKey) => ({
                url: `/PendingContract/DeletePendingContractScopeType?plPendingContractScopeKey=${plPendingContractScopeKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        pendingContractScopeEditSerialNumber: builder.mutation({
            query: ({plPendingContractScopeKey,psSerialNumber}) => ({
                url: `/PendingContract/PendingContractScopeEditSerialNumber?plPendingContractScopeKey=${plPendingContractScopeKey}&psSerialNumber=${psSerialNumber}`,
                method: 'POST',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updatePendingContract: builder.mutation({
            query: (data) => ({
                url: `PendingContract/UpdatePendingContract`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        pendingContractConvertToContract: builder.mutation({
            query: (data) => ({
                url: `/PendingContract/PendingContractConvertToContract`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
})

// Export hooks for API endpoints
export const {
    useGetPendingContractsListMutation,
    useGetActiveClientsMutation,
    useAddPendingContractMutation,
    useLazyGetPendingContractByIdQuery,
    useLazyGetClientByPendingContractIdQuery,
    useLazyGetPendingContractDepartmentsQuery,
    useDeletePendingContractDepartmentMutation,
    useLazyGetPendingContractDepartmentsAvailableQuery,
    useAddPendingContractDepartmentsMutation,
    useDeletePendingContractMutation,
    useLazyGetPendingContractAffiliatesQuery,
    useAddPendingContractAffiliateMutation,
    useDeletePendingContractAffiliateMutation,
    useLazyGetPendingContractScopesQuery,
    useLazyGetPendingContractScopesAvailableQuery,
    useAddPendingContractScopeMutation,
    useDeletePendingContractScopeMutation,
    useGetAffiliateDepartmentMutation,
    useSavePendingContractScopesMutation,
    useDeletePendingContractScopeTypeMutation,
    usePendingContractScopeEditSerialNumberMutation,
    useUpdatePendingContractMutation,
    usePendingContractConvertToContractMutation,
} = pendingContractAPI;

// Default export of pendingContract API
export default pendingContractAPI;
